if (window.jQuery) {

    (function ($) {

        // Get the video src from the data-src on each button
        var $videoSrc;
        $('.video').click(function () {
            $videoSrc = $(this).data("src");
        });

        // When the modal is opened autoplay it
        $('#videoModal').on('shown.bs.modal', function (e) {

            // Set the video src to autoplay and not to show related video
            $("#videoModalContainer").attr('src', $videoSrc + "&autoplay=1&amp;modestbranding=1&amp;showinfo=0");
        })

        // Stop playing the youtube video when I close the modal
        $('#videoModal').on('hide.bs.modal', function (e) {
            $("#videoModalContainer").attr('src', $videoSrc);
        })


    })(jQuery);

}